import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./FacilityTypeView.css";

const FacilityTypeView = (props) => {
  const { title, config, dataval } = props;
  const [rangetxt, setRangetxt] = useState("");
  const [data, setData] = useState({});
  const { t } = useTranslation();

  const getTitleIcon = (title) => {
    const lower = (title || "").toLowerCase();
    if (lower.includes("community") || lower.includes("kitchen")) {
      return (
        <span className="card-title-icon">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="white"><path d="M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 000 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"/></svg>
        </span>
      );
    }
    if (lower.includes("flood") || lower.includes("relief")) {
      return (
        <span className="card-title-icon">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"/></svg>
        </span>
      );
    }
    if (lower.includes("health") || lower.includes("camp")) {
      return (
        <span className="card-title-icon">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"/></svg>
        </span>
      );
    }
    return (
      <span className="card-title-icon">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/></svg>
      </span>
    );
  };

  useEffect(() => {
    // Calculate total meals served and update the dataval with the correct keyName
    const totalMealsServed = (dataval["Breakfast"] || 0) + (dataval["Lunch"] || 0) + (dataval["Dinner"] || 0);
    const updatedData = { ...dataval, "Total Meals served": totalMealsServed };

    if (props?.range === "TODAY") {
      setRangetxt("From Yesterday");
    } else if (props?.range === "WEEK") {
      setRangetxt("From Last Week");
    } else if (props?.range === "MONTH") {
      setRangetxt("From Last Month");
    }
    setData(updatedData);
  }, [props]);

  const getBackgroundClass = (index) => {
    const isLightTheme = document.getElementById("light") !== null;
  
    const darkThemeClasses = [
      "singleCardBlue",
      "singleCardperpel",
      "singleCardorange",
      "singleCardpink",
    ];
  
    const lightThemeClasses = [
      "singleCardBluelight",
      "singleCardperpellight",
      "singleCardorangelight",
      "singleCardpinklight",
    ];
  
    return isLightTheme
      ? lightThemeClasses[index % lightThemeClasses.length]
      : darkThemeClasses[index % darkThemeClasses.length];
  };
  
  return (
    <div className="card">
      <div className="card-body">
        <div className="card-title d-flex align-items-center" style={{color: "#0b2d4d", gap: "8px"}}>{getTitleIcon(title)}{title}</div>
        {config?.map((conf, index) => {
          return (
            <div key={index} className={getBackgroundClass(index)}>
              <div style={{marginTop: "5px", fontSize: "0.72rem"}}>{conf.label}</div>
              <div style={{marginTop: "5px", fontWeight: "bold", fontSize: "0.90rem"}}>{data[conf.keyName] || 0}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FacilityTypeView;